import { baseApi } from "./baseApi"

export interface SupportTicket {
  id: string
  status?: string
  subject?: string
  createdAt?: string
  [key: string]: unknown
}

export const supportApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSupportTickets: build.query<SupportTicket[], void>({
      query: () => ({ url: "/support/tickets", adminApi: "v1" }),
      providesTags: [{ type: "Support", id: "LIST" }],
    }),
    updateSupportTicket: build.mutation<SupportTicket, { id: string; status?: string; priority?: string }>({
      query: ({ id, ...body }) => ({ url: `/support/tickets/${id}`, method: "PATCH", body, adminApi: "v1" }),
      invalidatesTags: [{ type: "Support", id: "LIST" }],
    }),
  }),
})

export const { useGetSupportTicketsQuery, useUpdateSupportTicketMutation } = supportApi
